export interface Testimonial {
  role: string
  location: string
  text: string
  /** true until replaced with verified customer feedback */
  isSample: boolean
}

// Placeholder copy for layout only — replace with verified customer feedback before publication
// and set isSample to false.
export const shortTestimonials: Testimonial[] = [
  {
    role: 'Dog Grooming Instructor',
    location: 'United States',
    text: 'Having the grooming lesson structure already organized completely changes my preparation. I can choose the skill, review the visual progression and know exactly what I want to work on with my students.',
    isSample: true,
  },
  {
    role: 'Grooming Educator',
    location: 'United Kingdom',
    text: 'The visual breakdowns are the strongest part for me. Coat preparation, clipper work, shaping and finishing are much easier to explain when students can see the process before trying it.',
    isSample: true,
  },
  {
    role: 'Professional Grooming Instructor',
    location: 'Canada',
    text: 'The progressions, correction tools and assessments give my classes much more structure. I spend less time preparing and more time actually teaching.',
    isSample: true,
  },
]
